export const PENDING_LEAVE_ACTION = "PENDING_LEAVE_ACTION";


export const pendingLeave = () => {
    return{
        type: PENDING_LEAVE_ACTION
    }
}